import { isProd } from "../env";

type SiteImproveEventWithLabel = {
  action: SiteImproveActions;
  category: SiteImproveCategories;
  label: string;
};

export enum SiteImproveActions {
  BUTTON = "bruker klikket på en knapp",
  ACCORDION = "bruker åpnet/lukket en accordion",
  LINK = "bruker klikket på en link",
  LOGIN_WITH_IDPORTEN_LOGOUT = "bruker logget inn, og IDPorten-sesjon ble avsluttet",
  LOGIN_WITHOUT_IDPORTEN_LOGOUT = "bruker logget inn, men IDPorten-sesjon ble ikke avsluttet",
  LOGOUT_WITH_IDPORTEN_LOGOUT = "bruker logget ut, og IDPorten-sesjon ble avsluttet",
  LOGIN_WITH_SIGNICAT = "bruker logget inn med signicat",
}

export enum SiteImproveCategories {
  LOGIN_PRIVATE_USER = "login-private-user",
  LOGIN_BUSINESS_USER = "login-business-user",
  LOGOUT_PRIVATE_USER = "logout-private-user",
  MOBILEAPP = "mobileapp",
}

type SiteImprovePageView = [
  "trackdynamic",
  {
    url: string;
    ref?: string;
    title: string;
  },
];

type SiteImproveEvent = [
  "event",
  SiteImproveCategories,
  SiteImproveActions,
  string | undefined,
];

type SiteImproveToggleTrackingAction = ["notrack"] | ["notrack", false];

export type SiteImproveAction =
  SiteImprovePageView | SiteImproveEvent | SiteImproveToggleTrackingAction;

const siteImproveCache: Array<SiteImproveAction> = [];

const siteImproveScriptTagIsPresent = (): boolean =>
  document.getElementById("stag") !== null;

export function siteImproveEvent({
  action,
  category,
  label,
}: SiteImproveEventWithLabel): void {
  if (!isProd) {
    console.log(`Event:
      category: ${category}
      action: ${action}
      label: ${label}
      `);
  }
  const event: SiteImproveAction = ["event", category, action, label];
  if (window._sz && siteImproveScriptTagIsPresent()) {
    window._sz.push(event);
  } else {
    siteImproveCache.push(event);
  }
}

export const enableSiteImproveTracking = () => {
  const enableEvent: SiteImproveToggleTrackingAction = ["notrack", false];

  if (siteImproveScriptTagIsPresent()) {
    if (!window._sz) {
      siteImproveCache.push(enableEvent);
    } else {
      window._sz.push(enableEvent);
    }
    return;
  }

  const script = document.createElement("script");
  script.src = "https://siteimproveanalytics.com/js/siteanalyze_6015663.js";
  script.id = "stag";
  script.async = true;
  script.onload = () => {
    setTimeout(() => {
      siteImproveCache.forEach((action) => {
        if (window._sz) {
          window._sz.push(action);
        }
      });
    }, 500);
  };

  document.head.appendChild(script);
};
